import { TokenIO } from "@core/auth/login.interfaces";


export const parseToken = (token: string): TokenIO => {
  const jwt = JSON.parse(window.atob(token.split('.')[1])) as TokenIO;
  return jwt;
}
